import React, { useEffect, useRef, useState } from 'react'
import {
    IMetadataFilterSearchList,
    useGetFilterSearchListMetaDataValueMutation,
} from '../../Redux/VisualUnits/vuParamSlice'
import FilterValueDropdown from './HLFilterValueDropdown'
import { FilterValueOption } from '../../GenericComponents/filterTypes'
import { getCheckedFilterValues } from '../VuParamsHelpers'

const HLSearchlist = ({ data, selected, handleSelect, clearSelection, selectAll, selectFilterValueOptionFn }: any) => {

    const [totalSearchInfo, setTotalSearchInfo] = useState({
        totalRowCount: -1,
        totalValuesCount: -1,
    })
    const selectedIdsRef = useRef<Set<string>>(new Set())
    const [filterResp, setFilterResp] = useState<IMetadataFilterSearchList[]>([])

    const [searchedText, setSearchedText] = useState<string>('')
    const [callGetMetaDataSearchList] = useGetFilterSearchListMetaDataValueMutation()
    // const [selectedCheckboxValues, setSelectedCheckboxValues] = useState<any[]>([])
    const [filterValueOption, setFilterValueOption] = useState<FilterValueOption>('INCLUDE_ANY')
    const [searchResultsVisible, setSearchResultsVisible] = useState<boolean>(false)

    useEffect(() => {
        setFilterResp([])
        if (data.selectedParameters?.data !== null) {
            if(data.filterableMetaDataId === data.selectedParameters?.data.metaDataId){
                findKeyValues(data.selectedParameters.data.filterValue, data.selectedParameters.data.filterableValueDisplay)
            } else if(selected.length > 0) {
                selectedIdsRef.current.clear()
                clearSelection()
            }
        }
    }, [data.filterableMetaDataId])
    
    const findKeyValues = (filterValue: string, displayText: string) => {
        let selectedValues: string[] = getCheckedFilterValues(filterValue, displayText)
        if (data.selectedParameters.data.metaDataId == data.filterableMetaDataId) {
            findSearchListValues(displayText, true, selectedValues, data.filterableMetaDataId)
        } else {
            selectedIdsRef.current = new Set()
        }
    }

    useEffect(()=>{
        if(selected.length === 0){ //this is for clear all from Parent function call
            selectedIdsRef.current.clear()
        }
    },[selected])

    const selectFilterValueOption = (
        action: 'INCLUDE_ANY' | 'EXCLUDE_ANY' | 'INCLUDE_ALL' | 'EXCLUDE_ALL'
    ) => {
        setFilterValueOption(action)
        selectFilterValueOptionFn(action)
    }

    const findSearchListValues = (text: string = "", updateCall:boolean=false, filterValuesAttr:string[]= [], metaDataIdAttr: number = 0) => {
        let textVal = text
        let searchListPayload = {}
        let initpayload = { filterValueTextString: textVal, metaDataId: data.filterableMetaDataId }
        let updateCallPayload = {filterValueText: textVal, filterValues: filterValuesAttr, metaDataId: metaDataIdAttr}
        searchListPayload = updateCall ? updateCallPayload : initpayload;

        callGetMetaDataSearchList(searchListPayload)
            .unwrap()
            .then((resp) => {
                if (resp.statusCode == 201) {
                    if(!updateCall){ //check for api hit from update or not..
                        setFilterResp(resp.data.filterValueList)
                        setSearchResultsVisible(true) 
                        setTotalSearchInfo({
                            totalRowCount: resp.data.totalRowCount,
                            totalValuesCount: resp.data.totalValuesCount,
                        })
                    }else{
                        let metadataValues:IMetadataFilterSearchList[] = [];
                        if(resp.data.MetaDataValues.length > 0){
                            resp.data.MetaDataValues.forEach((itr:IMetadataFilterSearchList) => metadataValues.push(itr))
                        }
                        selectAllFilterValues(metadataValues)
                    }
                }
            })
    }

    const selectAllFilterValues = (filterResp: any[]) => {
        filterResp.forEach((item) => selectedIdsRef.current.add(item.KeyValue));
        selectedIdsRef.current = new Set(filterResp.map((item) => item.KeyValue))
        selectAll(filterResp)
    }

    const selectCheckBoxValues = (item: IMetadataFilterSearchList) => {
        const key = item.KeyValue
        if (selectedIdsRef.current.has(key)) {
            selectedIdsRef.current.delete(key)
        } else {
            selectedIdsRef.current.add(key)
        }
        handleSelect(item, true, selectedIdsRef.current, key)
    }

    return (
        <div id="vu_popup_searchlist_props" className="vu-popup-searchlist-props">
            <div className="searchlist-popup-find-wrapper">
                <div className="searchlist-popup-header">
                    <input
                        type="text"
                        id="vu_popup_searchlist_text"
                        onChange={(e) => setSearchedText(e.target.value)}
                        maxLength={100}
                        size={40}
                    />
                    <button
                        type="button"
                        id="vu_popup_searchlist_button"
                        className="ui-button app-button"
                        onClick={() => findSearchListValues(searchedText)}
                    >
                        <span className="ui-button-text">Find</span>
                    </button>
                </div>
                {!searchResultsVisible ? (
                    <ul
                        id="vu_popup_searchlist_list"
                        className="filtervalue-list searchlist-popup-list-filterable filtervalue-list-multiple"
                    >
                        <li className="info field-optional">Enter few characters of a filter value and click Find.</li>
                    </ul>
                ) : (
                <>
                <ul
                    id="vu_popup_searchlist_list"
                    className="filtervalue-list searchlist-popup-list-filterable filtervalue-list-multiple"
                >
                    {filterResp.length > 0 ?(
                        filterResp.map((itr: IMetadataFilterSearchList, _index: number) => {
                            return (
                                <li
                                key={`HLSearchlist_item_${_index}`}
                                    onClick={() => selectCheckBoxValues(itr)}
                                    id={`filtervalue_item_${itr.KeyValue}`}
                                    className={
                                        selectedIdsRef.current.has(itr.KeyValue) && selected.length
                                            ? 'selected'
                                            : 'not-selected'
                                    }
                                >
                                    <div className="float-left fieldcheckbox">
                                        <input
                                            checked={selectedIdsRef.current.has(itr.KeyValue) && selected.length}
                                            type="checkbox"
                                            readOnly
                                            id={`filtervalue_checkbox_${itr.KeyValue}`}
                                            name="filtervalue_checkbox"
                                            value={itr.KeyValue}
                                        />
                                    </div>
                                    <div className="float-left fieldcontent">{itr.DisplayText}</div>
                                    <div className="clear-both"></div>
                                </li>
                            )
                        })
                    ):(
                            <li className="info">Sorry, no filter value matched. Try a different value.</li>
                        )}      
                </ul>
                {filterResp.length > 0 && (
                <>
                <div
                    id="vu_popup_searchlist_list_filter_options"
                    className="vu-popup-filter-options-1"
                >
                    <span id="vu_popup_searchlist_list_count">{totalSearchInfo.totalValuesCount === -1 ? 0 : totalSearchInfo.totalValuesCount}</span> items •
                    <a
                        href="javascript:void(0);"
                        onClick={() => selectAllFilterValues(filterResp)}
                    >
                        select all
                    </a>
                </div>
                
                {totalSearchInfo.totalValuesCount !== -1 && (
                    <div id="vu_popup_searchlist_info" className="searchlist-popup-info">
                        {totalSearchInfo.totalValuesCount} of {totalSearchInfo.totalRowCount}{' '}
                        matched values are displayed.
                    </div>
                )}
                </>
                )}
            </>
            )}
                <div id="vu_popup_searchlist_valmsg" className="field-validation-error hide"></div>
            </div>
            <div className="searchlist-popup-sel-wrapper">
                <FilterValueDropdown selectedDropdownOptn = {data.selectedParameters.data?.filterOptions} selectFilterValueOptionFn={selectFilterValueOption} />
                <span style={{ marginBottom: '10px' }} className="vu-popup-element-subheader">
                    Selected values
                </span>

                <div
                    id="vu_params_searchlist_filter_options"
                    className="searchlist-filter-options"
                ></div>
                <ul
                    id="vu_popup_searchlist_sel_list"
                    className="filtervalue-list searchlist-popup-list-filterable filtervalue-list-multiple"
                >
                    {
                        // here
                        selected.length > 0 ? (
                            selected.map((itr: any, index: any) => {
                                return (
                                    <>
                                        <li
                                        key={`Selected_HLSearchList_${index}`}
                                            id={`filtervalue_item_sel_${itr.KeyValue}`}
                                            onClick={() => selectCheckBoxValues(itr)}
                                            className="selected"
                                        >
                                            <div className="float-left fieldcheckbox">
                                                <input
                                                    type="checkbox"
                                                    id={`filtervalue_checkbox_sel_${itr.KeyValue}`}
                                                    name="filtervalue_checkbox_sel"
                                                    checked={true}
                                                    value={itr.KeyValue}
                                                    readOnly
                                                />
                                            </div>
                                            <div className="float-left fieldcontent">
                                                {itr.DisplayText}
                                            </div>
                                            <div className="clear-both"></div>
                                        </li>
                                    </>
                                )
                            })
                        ) : (
                            <li className="info field-optional">Find and select filter values above.</li>
                        )}                   
                </ul>
            </div>
            {/* <div
                id="vu_popup_searchlist_sel_list_filter_options"
                className="vu-popup-filter-options-1"
            >
                <a
                    href="javascript:void(0);"
                    onClick={() => clearAllFilterValues('HLSearchList')}
                >
                    clear all
                </a>
            </div> */}
        </div>
    )
}

export default HLSearchlist
